import 'bootstrap/dist/css/bootstrap.min.css';
import "./assets/css/global.scss";
import "./assets/css/media.scss";
import "./assets/css/table.scss";
import "./assets/css/form.scss";
import "./assets/css/dropdown.scss";
import "./assets/css/input.scss";
import "./assets/css/checkbox.scss";
import "./assets/css/textarea.scss";
import "./assets/css/button.scss";

import 'bootstrap/js/dist/dropdown';

import { Suspense, useEffect } from "react";
import { RouterProvider, createBrowserRouter } from 'react-router-dom';

// store
import { useDispatch } from "react-redux";
import { fetchPublicKey } from "./stores/slice/publicKey";
import { fetchServerSetting } from "./stores/slice/serverSetting";
import { fetchSupportSetting } from './stores/slice/supportSetting';
import { fetchNotice } from './stores/slice/notice';

//Router
import { getRoutes } from "./router";

function App() {
  const dispatch = useDispatch();
  let createRouter = createBrowserRouter(getRoutes());

  // uauth api
  useEffect(() => {
    dispatch(fetchPublicKey());
    dispatch(fetchServerSetting());
    dispatch(fetchSupportSetting());
    dispatch(fetchNotice());
  }, [dispatch]);

  return (
    <>
      <Suspense fallback={<div>Loading...</div>}>
        {createRouter && <RouterProvider router={createRouter} />}
      </Suspense>
    </>
  );
}

export default App;